module.exports = __webpack_public_path__ + "img/portrait-rank-16@3x.01d823b3.png";